import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { TabsUnderline, usePageTitle } from '../../components/app2';
import authService from '../../utils/authService';

/**
 * Marco de la sección "Mi cuenta" (rediseño jul-2026).
 *
 * Antes tenía su PROPIO menú lateral. Con el shell nuevo eso dejaba tres
 * niveles de navegación apilados (menú de la app + menú de la cuenta +
 * contenido), así que se cambia por la barra de pestañas que usa el diseño.
 * Los destinos son exactamente los mismos y se siguen filtrando por rol: solo
 * el administrador de empresa ve plan, cambio de plan y facturación.
 *
 * El título de cada pantalla ya no se pinta como <h1> dentro del contenido: lo
 * muestra el header del shell.
 */

const NAV_ITEMS = [
  { id: 'plan', label: 'Mi plan', path: '/app/account/plan', companyOnly: true },
  { id: 'upgrade', label: 'Cambiar plan', path: '/app/account/plans/upgrade', companyOnly: true },
  { id: 'billing', label: 'Facturación', path: '/app/account/billing', companyOnly: true },
  { id: 'profile', label: 'Mi perfil', path: '/app/account/profile', companyOnly: false },
];

const AccountLayout = ({ title, subtitle, headerActions, children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentUser = authService?.getCurrentUser();
  const isCompanyAdmin = currentUser?.role === 'company';

  const visibleNav = NAV_ITEMS.filter((item) => !item.companyOnly || isCompanyAdmin);

  const active = visibleNav.find((item) =>
    location.pathname === item.path || location.pathname.startsWith(`${item.path}/`)
  );

  usePageTitle({ kicker: 'Cuenta', title });

  return (
    <div className="a2-anim-screen">
      {visibleNav.length > 1 ? (
        <div
          style={{
            display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between',
            flexWrap: 'wrap', gap: 12, marginBottom: 22,
          }}
        >
          <TabsUnderline
            items={visibleNav.map(({ id, label }) => ({ id, label }))}
            value={active?.id}
            onChange={(id) => {
              const target = visibleNav.find((item) => item.id === id);
              if (target) navigate(target.path);
            }}
            style={{ flex: 1, minWidth: 240 }}
          />
          {headerActions ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, paddingBottom: 8 }}>
              {headerActions}
            </div>
          ) : null}
        </div>
      ) : null}

      {/* Con una sola pestaña (super admin y colaborador solo ven "Mi perfil")
          no se dibuja la barra: el subtítulo y las acciones comparten la misma
          línea, para no dejar una franja vacía arriba. */}
      {subtitle || (visibleNav.length <= 1 && headerActions) ? (
        <div
          style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            flexWrap: 'wrap', gap: 12, marginBottom: 16,
          }}
        >
          {subtitle ? (
            <p style={{ font: "500 .9rem 'Hanken Grotesk'", color: 'var(--muted)', margin: 0 }}>
              {subtitle}
            </p>
          ) : null}
          {visibleNav.length <= 1 && headerActions ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginLeft: 'auto' }}>
              {headerActions}
            </div>
          ) : null}
        </div>
      ) : null}

      {children}
    </div>
  );
};

export default AccountLayout;
